import React, { useState, useEffect } from 'react';
import LoadingOverlay from './LoadingOverlay';
import { Button } from './ui/button';

const TestOverlay: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState({ current: 0, total: 10 });

  const toggleOverlay = () => {
    setVisible(!visible);
    console.log('Toggling overlay to:', !visible);
    if (!visible) {
      // Reset progress when showing
      setProgress({ current: 0, total: 10 });
    }
  };

  useEffect(() => {
    let interval: NodeJS.Timeout;
    
    if (visible && progress.current < progress.total) {
      interval = setInterval(() => {
        setProgress(prev => {
          const newCurrent = Math.min(prev.current + 1, prev.total);
          console.log('Updating progress:', newCurrent, 'of', prev.total);
          return { ...prev, current: newCurrent };
        });
      }, 500);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [visible, progress]);

  return (
    <div className="p-4">
      <Button onClick={toggleOverlay}>
        {visible ? 'Hide Overlay' : 'Show Overlay'}
      </Button>
      <div className="mt-4">
        Progress: {progress.current} of {progress.total}
      </div>
      <LoadingOverlay visible={visible} progress={progress} />
    </div>
  );
};

export default TestOverlay;